<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col>
        <v-card>
          <template v-slot:heading>
            <div class="text-subtitle-1 font-weight-light" />
            <div class="text-h4 font-weight-light">
              Участники
            </div>
          </template>
          <v-data-table
            :headers="headers"
            :items="userProfiles"
            :footer-props="datatable_footer"
            :loading="loading"
            :server-items-length="total"
            :options.sync="table_options"
            no-data-text="Нет данных для отображения"
            @click:row="getRow"
          >
            <template v-slot:footer.page-text="{pageStart,pageStop,itemsLength}">
              {{ pageStart }}-{{ pageStop }} из {{ itemsLength }}
            </template>
            <template v-slot:top>
              <v-card flat>
                <v-card-text>
                  <v-row dense>
                    <v-col
                      cols="12"
                      md="3"
                    >
                      <autocomplete
                        ref="autocomplete"
                        :get-result-value="getResultValue"
                        :search="search"
                        @submit="onSubmit"
                      />
                    </v-col>
                    <v-col
                      cols="12"
                      sm="5"
                      md="5"
                      class="d-flex justify-sm-end"
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="primary"
                            v-bind="attrs"
                            class="ma-1 pa-1"
                            @click="onCreateUserProfile"
                            v-on="on"
                          >
                            <v-icon class="ml-3">
                              mdi-plus
                            </v-icon>
                            <span class="md-1 mx-3">Добавить</span>
                          </v-btn>
                        </template>
                        <span>Создать нового Участника</span>
                      </v-tooltip>
                    </v-col>
                    <v-col
                      cols="12"

                      md="4"
                      class="d-flex  justify-md-end"
                    >
                      <v-btn
                        color="red"
                        outlined
                        class="ma-1 pa-1"
                        @click="dialogUploadVisible=true"
                      >
                        <v-icon class="ml-3">
                          mdi-download
                        </v-icon>
                        <span class="mx-3">Импортировать</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </template>
            <template v-slot:item.accounts="{ item }">
              <v-icon
                @click="getAccounts(item)"
              >
                mdi-account-details-outline
              </v-icon>
            </template>
            <template v-slot:item.actions="{ item }">
              <task-menu
                :task-items="taskItems"
                @cashIn="onCashIn(item)"
                @delete="deleteItem(item)"
                @edit="onEdit(item)"
              />
            </template>
            <template v-slot:item.availability="{item}">
              <v-checkbox
                v-model="item.availability"
              />
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <user-profile-upload-dialog
          :customer-id="customerId"
          :customer-number="customerNumber"
          :dialog-visible="dialogUploadVisible"
          @close="onUploaded"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <user-profile-create
          :customer-id="customerId"
          :customer-number="customerNumber"
          :dialog-visible="dialogUserCreateVisible"
          :is-creating="isCreating"
          :user-profile="currentUserProfile || new UserProfileModel()"
          @close="dialogUserCreateVisible=false"
          @create="onCreatedUserProfile"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <user-profile-account-edit
          :campaign-id="campaign.campaignId"
          :dialog-visible="dialogAccountVisible"
          :user-profile="currentUserProfile || new UserProfileModel()"
          @added="onCached"
          @close="dialogAccountVisible=false"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import WebApi from "../../shared/modules/web_api"
import { UserProfileModel, UserProfileHeadersModel, UserModelTitlesModel } from "../../models/user-profile.model"
import TaskMenu from "../../shared/components/task-menu/TaskMenu"
import {
  getObjectsForSearching,
  getSearchedObjects
} from "@/views/loyalty/shared/modules/utilities"
import Autocomplete from "@/views/loyalty/shared/components/search-autocomplete/Autocomplete"
import { Userprofile } from "@/views/loyalty/shared/services/userprofile-service"
import { localStock } from "@/views/loyalty/shared/classes/local_stock"
import { SearchStuffModel } from "@/views/loyalty/models/search_stuff.model"
import { TransactionTitlesModel } from "@/views/loyalty/models/transaction.model"
import { AccountService } from "@/views/loyalty/shared/services/account-service"
import { JustpayClient } from "@/views/loyalty/shared/services/justpay-client-service"
import UserProfileUploadDialog from "@/views/loyalty/components/user_profile/UserProfileUploadDialog.vue"
import UserProfileCreate from "@/views/loyalty/components/user_profile/UserProfileCreate.vue"
import UserProfileAccountEdit from "@/views/loyalty/components/user_profile/UserProfileAccountEdit.vue"

export default {
  name: "UserProfileList",
  components: {
    Autocomplete,
    TaskMenu,
      UserProfileAccountEdit,
      UserProfileCreate,
      UserProfileUploadDialog,
  },
  data: () => ({
    accountService: null,
    datatable_footer: {
      itemsPerPageText: 'Показывать по',
      pageText: 'из',
      itemsPerPageAllText: 'Все',
    },
    dialogVisible: false,
      dialogUploadVisible: false,
      dialogUserCreateVisible: false,
      dialogAccountVisible: false,
    campaign: null,
      currentUserProfile: null,
    customerId: "",
      customerNumber: null,
    headers: [
      {
        text: 'Действия',
        value: 'actions',
          sortable: false
      }
    ],
    headerService: null,
      isCreating: false,
      justpayClientService: null,
    loading: false,
    role: 0,
    participantAccounts: [],
    searchStuff: null,
    table_options: {},
      taskItems: [{
        title: 'Пополнить счёт',
          icon: "mdi-wallet-outline",
          click () { this.$emit('cashIn') }
      }, {
          title: 'Редактировать',
          icon: "mdi-pencil",
          click () { this.$emit('edit') }
      }],
    total: 0,
    userProfiles: [],
    userProfileService: null,
    webApi: null
  }),
    computed: {
        UserProfileModel () {
            return UserProfileModel
        }
    },
  watch: {
    table_options: {
      async handler () {
        console.log(this.table_options)
        const { sortBy, sortDesc, page, itemsPerPage } = this.table_options
        this.userProfiles = await this.getItems()
      },
      deep: true,
    },
  },
  beforeMount () {
    this.webApi = new WebApi(this.$store).readError("Ошибка при чтении данных")
    this.accountService = new AccountService()
      this.justpayClientService = new JustpayClient()
    this.userProfileService = new Userprofile()
    this.role = +this.$route.params.role
    this.campaign = localStock.getItem('campaign')
  },
  async mounted () {
      if (!this.campaign) {
          this.customerId = localStorage.getItem('client')
      } else {
          this.customerId = this.campaign.customerId // campaignId
      }
      this.customerNumber = await this.justpayClientService.getClientNumber(this.customerId)
    this.headers = [...this.headers, ...UserProfileHeadersModel, { text: 'Доступность', value: 'availability' }]
    console.log("customerId", this.customerId)
    console.log("this.role", this.role)
    this.fillSearchStuff()
    this.userProfiles = await this.getItems()
  },
  methods: {
    fillSearchStuff () {
      this.searchStuff = Object.assign({}, SearchStuffModel)
      this.searchStuff.fieldNames = UserModelTitlesModel.map(m => Object.fromEntries(Object.entries(m).filter(([key, value]) => {
        if ((key === 'value' || key === 'filterType')) { return value } else { return false }
      }))).filter(f => ['name', 'surname', 'login', 'email', 'cardNumber', 'expiredDate'].includes(f.value)) // .map(obj => obj.value) &&
      console.log('this.searchStuff:', this.searchStuff)
    },
    async getItems () {
      this.loading = true
         const userProfiles = await this.userProfileService.getUserProfileListByCustomerId(this.customerId, this.table_options.page, this.table_options.itemsPerPage, [], this.searchStuff)
        console.log('userProfiles', userProfiles)
        this.total = userProfiles.count

        // Get account
        const userProfileCampaigns = await Promise.all(userProfiles.items.map(async item => {
            let userProfile = Object.assign({}, item.UserProfileInDb)
            if (item.CardInDb) {
                userProfile = Object.assign(userProfile, item.CardInDb)
            } else {
                userProfile = Object.assign(userProfile, { cardNumber: '', expiredDate: '' })
            }
          const campaign_account = await this.accountService.getParticipantAccounts(item.UserProfileInDb.userProfileId)

        // console.log('campaign_account', campaign_account)
          const participant_data = campaign_account.find(f => f.campaign.campaignId === this.campaign.campaignId)
          // console.log('participant_data', participant_data)
          if (participant_data !== undefined) {
            userProfile.amount = participant_data.account.Amount
          }
          // console.log('userProfile', userProfile)
          return userProfile
        }))
        // console.log('userProfileCampaigns', userProfileCampaigns)

      // ///////////////////////////  get availability ////////////////////////////////////////////////////////
        const avail_participants = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/participant/`)
        // console.log('avail_participants', avail_participants)
        const userProfileCampaignsAvailability = userProfileCampaigns.map(item => {
          const participant = avail_participants.find(f => f.userId === item.userProfileId && f.campaignId === this.campaign.campaignId)
          if (participant !== undefined ? participant.availability : false) {
              Reflect.set(item, 'availability', participant.availability)
          }
          return item
        })
      // console.log('->userProfileCampaignsAvailability:', userProfileCampaignsAvailability)
        this.loading = false
      return userProfileCampaignsAvailability.map(k => k)
      // return userProfiles.items
    },
    getRow (point) {
      console.log('getRow point', point)
      console.log('getRow this.campaign', this.campaign)
      this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}api/participant/${this.campaign.campaignId}/${point.userProfileId}/${point.availability}`)
    },
    getResultValue (result) {
      return result.searched
    },
      onCashIn (item) {
        console.log('+++ cashIn event')
          console.log('item', item)
          this.dialogAccountVisible = true
          this.currentUserProfile = item
      },
      async onCached () {
          this.dialogAccountVisible = false
          this.userProfiles = await this.getItems()
      },
      onCreateUserProfile () {
        console.log('+++ Creating UserProfile')
          this.dialogUserCreateVisible = true
          this.isCreating = true
      },
      async onCreatedUserProfile () {
          this.dialogUserCreateVisible = false
          this.userProfiles = await this.getItems()
      },
      onEdit (item) {
        this.dialogUserCreateVisible = true
          this.isCreating = false
          console.log('item', item)
          this.currentUserProfile = item
      },
    async onSubmit (result) {
      const searching = result.searched ? result.searched : result
      console.log('searching.length', searching.length)
      if (searching.length !== 0) {
        this.searchStuff.fieldValue = searching
        this.userProfiles = await this.getItems()
      } else {
        this.searchStuff.fieldValue = ''
        // this.pageStop = -1
        this.userProfiles = await this.getItems()
      }
    },
      async onUploaded () {
          this.dialogUploadVisible = false
          await this.getItems()
      },
    search (input) {
      console.log('search', input)
      if (input.length < 1) { return [] }
      const arr = getSearchedObjects(this.userProfiles, input)
      console.log('arr', arr)
      return arr
    },
    setItems (data) {
      return Reflect.construct(UserProfileModel, [data])
    }
  }
}
</script>

<style scoped></style>
